import { HotmartRum } from '@hot-observability-js/react';
import pkjson from '../../../package.json';

const initSentry = () => {
  HotmartRum.init({
    dsn: process.env.SENTRY_DSN,
    environment: process.env.TARGET_ENV === 'production' ? 'production' : 'staging',
    release: `${pkjson.name}@${pkjson.version}`,
    dynamicSetup: true
  });
};

if (process.env.TARGET_ENV !== 'development') {
  initSentry();
}
